import { intl } from 'src/i18n'

// eslint-disable-next-line import/no-anonymous-default-export
export default (): any => ({
  chart: {
    panning: true,
    animation: false,
    type: 'line',
    zoomType: 'x',
    backgroundColor: '#1d1d1e',
    plotBorderWidth: 0,
    plotBorderColor: 'rgba(255, 255, 255, 0.1)',
    marginBottom: 10,
    marginTop: 50,
    spacing: [0, 0, 0, 0],
    selectionMarkerFill: 'rgba(132, 196, 124, 0.1)',
  },
  navigation: {
    buttonOptions: {
      enabled: false,
    },
  },
  loading: {
    labelStyle: {
      color: '#fff',
    },
    style: {
      backgroundColor: 'transparent',
    },
  },
  exporting: {
    enabled: true,
    allowHTML: true,
    scale: 1,
    buttons: {
      contextButton: {
        y: 7,
        x: -5,
        menuClassName: 'Chart-export-menu',
        symbol: 'download',
        symbolStroke: '#616161',
        symbolStrokeWidth: 2,
        // menuItems: ['downloadPNG', 'downloadJPEG', 'downloadSVG', 'separator', 'downloadCSV', 'downloadXLS'],
        menuItems: ['downloadPNG', 'downloadJPEG', 'downloadSVG'],
        theme: {
          fill: 'transparent',
          cursor: 'pointer',
          states: {
            hover: {
              fill: 'transparent',
            },
            select: {
              fill: 'transparent',
            },
          },
        },
      },
    },
    menuItemDefinitions: {
      downloadPNG: {
        text: `${intl.t('components.timeLineChart.download')} PNG`,
      },
      downloadJPEG: {
        text: `${intl.t('components.timeLineChart.download')} JPEG`,
      },
      downloadPDF: {
        text: `${intl.t('components.timeLineChart.download')} PDF`,
      },
      downloadSVG: {
        text: `${intl.t('components.timeLineChart.download')} SVG`,
      },
    },
    chartOptions: {
      plotOptions: {
        area: {
          fillColor: 'rgba(255, 255, 255, 0.25)',
        },
      },
      xAxis: {
        scrollbar: {
          enabled: false,
        },
      },
    },
  },
  title: {
    text: '',
  },
  credits: {
    text: '',
    href: '',
  },
  xAxis: [
    {
      type: 'datetime',
      lineColor: 'rgba(255, 255, 255, 0.5)',
      crosshair: {
        dashStyle: 'Solid',
        color: 'rgba(255, 255, 255, 0.4)',
        width: 1,
      },
      gridLineWidth: 0,
      minorTickLength: 0,
      lineWidth: 0,
      tickLength: 6,
      tickColor: 'rgba(255, 255, 255, 0.4)',
      tickPixelInterval: 10,
      startOnTick: false,
      endOnTick: false,
    },
  ],
  yAxis: [],
  rangeSelector: {
    enabled: false,
  },
  plotOptions: {
    series: {
      dataGrouping: {
        enabled: true,
      },
      showInNavigator: true,
      states: {
        hover: {
          enable: false,
          halo: {
            size: 0,
          },
          lineWidthPlus: 0,
        },
      },
    },
    line: {
      marker: {
        enabled: false,
        states: {
          hover: {
            radius: 4,
            lineWidth: 2,
            lineColor: '#fff',
          },
        },
        symbol: 'circle',
      },
      animation: {
        duration: 300,
      },
    },
    column: {
      borderWidth: 0,
      groupPadding: 0,
      shadow: false,
    },
    area: {
      width: 0,
      borderWidth: 0,
      animation: {
        duration: 300,
      },
      marker: {
        enabled: false,
        states: {
          hover: {
            radius: 4,
            fillColor: '#000',
            lineWidth: 1,
            lineColor: '#fff',
          },
        },
      },
      lineWidth: 0,
      threshold: null,
      events: {},
      states: {
        hover: {
          enabled: true,
          halo: {
            size: 0,
          },
          lineWidth: 0,
          lineWidthPlus: 0,
        },
      },
    },
  },
  navigator: {
    adaptToUpdatedData: false,
    series: {
      data: [],
      lineColor: '#84c47c',
      fillOpacity: 0,
    },
    xAxis: {
      gridLineColor: '#555555',
    },
    height: 80,
    outlineColor: '#555555',
    maskFill: 'rgba(132, 196, 124, 0.1)',
    handles: {
      backgroundColor: '#5A5C5A',
      borderColor: '#2B2B2B',
      width: 16,
      height: 32,
    },
  },
  scrollbar: {
    liveRedraw: false,
    barBackgroundColor: '#424342',
    buttonBackgroundColor: '#383938',
    trackBackgroundColor: '#383938',
    buttonArrowColor: '#383938',
    barBorderColor: '#424342',
    buttonBorderColor: '#383938',
    trackBorderColor: '#383938',
  },
  series: [],
  tooltip: {
    split: false,
    borderWidth: 0,
    padding: 0,
    shape: 'square',
    useHTML: true,
    followPointer: true,
    shared: true,
  },
})
